import React, {PropsWithChildren} from 'react';
import clsx from 'clsx';

import {InputBase} from '@material-ui/core';

import useStyles from './styles';

interface AdornmentTextFieldProps {
  id?: string
  className?: string
  inputClassName?: string
  type: string
  value?: string
  defaultValue?: string
  placeholder?: string

  onChange?(e: React.ChangeEvent<HTMLInputElement>): void

  onKeyDown?(e: React.KeyboardEvent<HTMLInputElement>): void
  onClick?(): void
  onFocus?():void
}

const AdornmentTextField = (props: PropsWithChildren<AdornmentTextFieldProps>) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, props.className)}>
      <InputBase
        type={props.type}
        className={classes.input}
        inputProps={{
          id: props.id,
          className: props.inputClassName,
          type: props.type
        }}
        defaultValue={props.defaultValue}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        onKeyDown={props.onKeyDown}
        onFocus={props.onFocus}
      />
      <div style={{width: 24, height: 24}}>
        {props.children}
      </div>
    </div>
  );
};

export default AdornmentTextField;
